import { ReactNode, useState } from 'react';
import { CustomerDto } from '../commons/dtos/customer.dto';
import PublicFormContext from '../contexts/publicForm.context';

const PublicFormProvider = ({ children }: { children: ReactNode }) => {
  const [customer, setCustomer] = useState<CustomerDto>();
  const [step, setStep] = useState(1);

  const value = { customer, setCustomer, step, setStep };

  return <PublicFormContext.Provider value={value}>{children}</PublicFormContext.Provider>;
};

export default PublicFormProvider;
